/**
 * Leaflet map initialization
 */

import L from 'leaflet';

/**
 * Initializes the Leaflet map centered on the UK
 * @param containerId - The HTML element ID for the map container
 * @returns Configured Leaflet map instance
 */
export function initializeMap(containerId: string): L.Map {
  // Center on UK (approximate geographic center)
  const ukCenter: L.LatLngExpression = [54.5, -3.5];
  const initialZoom = 6;

  // Create map instance
  const map = L.map(containerId, {
    center: ukCenter,
    zoom: initialZoom,
    zoomControl: true,
    scrollWheelZoom: true,
  });

  // Add OpenStreetMap tile layer
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
    minZoom: 5,
  }).addTo(map);

  console.log('Map initialized at UK center:', ukCenter);

  return map;
}
